import wardLayer from '@/constants/wardLayer'
import symbols from '@/constants/symbols'

export default class alertWardLayer extends wardLayer {
	constructor(elevatedThreshold, criticalThreshold) {
		super(elevatedThreshold, criticalThreshold)
		this.layer = {
			...this.layer,
			labelingInfo: [symbols.wardNameGreenLabel, symbols.wardNameYelloLabel, symbols.wardNameRedLabel],
			renderer: {
				type: 'class-breaks',
				field: 'incident',
				defaultSymbol: symbols.redWardSymbol,
				classBreakInfos: [
					{
						minValue: elevatedThreshold,
						maxValue: criticalThreshold - 1,
						symbol: symbols.yellowWardSymbol
					},
					{
						minValue: 0,
						maxValue: elevatedThreshold - 1,
						symbol: symbols.greenWardSymbol
					}
				]
			}
		}
	}
}
